module.exports = __webpack_public_path__ + "img/loading.464ed3b8.gif";